const AUTH_COOKIE_NAME = 'authInfo'

export type AuthInfoType = {
  accessToken: string
  refreshToken?: string
}

export class AuthCookieService {
  /**
   * Store authentication information to cookie
   */
  public static async storeAuthInfo(authInfo: AuthInfoType, persistent: boolean): Promise<void> {
    const defaultDuration = 1000 * 60 * 60 * 24 * 62 // 62 days in milliseconds
    const duration = persistent ? defaultDuration : 0
    AuthCookieService.store(AUTH_COOKIE_NAME, authInfo, duration)
  }

  /**
   * Get authentication information from cookie
   */
  public static async getAuthInfo(): Promise<AuthInfoType | undefined> {
    return AuthCookieService.get(AUTH_COOKIE_NAME)
  }

  /**
   * Clear authentication information cookie
   */
  public static async clearAuthInfo(): Promise<void> {
    const d: Date = new Date()
    d.setTime(0)

    AuthCookieService.write(AUTH_COOKIE_NAME, '', d.toUTCString())
  }

  /**
   * Generic value store to cookie
   */
  private static store(cookieName: string, value: any, duration: number): void {
    const cookieValue = JSON.stringify(value)

    let expires = ''
    if (duration) {
      const d = new Date()
      d.setTime(d.getTime() + duration)
      expires = d.toUTCString()
    }

    AuthCookieService.write(cookieName, cookieValue, expires)
  }

  /**
   * Generic value get from cookie
   */
  private static get(cookieName: string): any {
    try {
      const value = AuthCookieService.read(cookieName)
      if (value) {
        return JSON.parse(decodeURIComponent(value))
      }
    } catch (error) {
      console.error('Error getting cookie:', error)
    }
    return undefined
  }

  private static write(cookieName: string, value: string, expires: string): void {
    const expiresPart = expires ? `; expires=${expires}` : ''
    document.cookie = `${cookieName}=${encodeURIComponent(value)}${expiresPart}; path=/`
  }

  private static read(cookieName: string): string | undefined {
    for (const cookie of document.cookie.split('; ')) {
      const separatorIndex = cookie.indexOf('=')
      if (separatorIndex !== -1 && cookie.slice(0, separatorIndex) === cookieName) {
        return cookie.slice(separatorIndex + 1)
      }
    }
    return undefined
  }
}
